import { makeStyles } from "@mui/styles";
import React from "react";
import About from "../Pages/About";
import SkillsExperience from "../Pages/SkillsExperience";
import Footer from "../Pages/Footer";
import Contact from "../Pages/Contact";
import Project from "../Pages/Project";

const useStyles = makeStyles({
  container: {
    color: "white",
    width: "100%",
    minHeight: "100vh",
    // paddingLeft: "15rem",
    position: "absolute",
  },
});

function PageMainContainer() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <About />
      <SkillsExperience />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
}

export default PageMainContainer;
